import { Component, OnDestroy, OnInit } from '@angular/core';
import { FieldType, FieldTypeConfig } from '@ngx-formly/core';
import { CurrencyModel } from '../../models/base.models';
import { ApiService } from '../../services/api.service';
import { lastValueFrom } from 'rxjs';

@Component({
  selector: 'formly-field-system-currency',
  template: `

  <div class="mb-3">
  <label class="form-label" [for]="field.id"> {{field.props.label}} <span *ngIf="field.props.required" aria-hidden="true">*</span></label>
    <ng-select class="ng-select-solid" [ngClass]="{ 'is-invalid': formControl.invalid && formControl.touched }" [labelForId]="field.id" [placeholder]="field.props.placeholder" [editableSearchTerm]="false" [clearSearchOnAdd]="false" [clearable]="false" type="input"[multiple]="false" [formControl]="formControl" >
      <ng-option *ngFor="let currency of currenciesList; let i=index" [value]="currency.id">
        <span class="badge px-1 badge-square badge-light-primary">{{currency.code}}</span> {{currency.name}}
      </ng-option>
    </ng-select>
    </div>
  `,
})
export class systemCurrencyFieldType extends FieldType<FieldTypeConfig> implements OnInit, OnDestroy {
  currenciesList: CurrencyModel[] = []

  constructor(private api: ApiService) {
   super()
  }

  ngOnDestroy(): void {
    this.formControl?.reset();
  }


  async ngOnInit() {
    this.currenciesList = await this.getCurrencies();
  }



  async getCurrencies() {
    let request$ = this.api.getCurrencies();
    let response = await lastValueFrom(request$);

    console.log(response);
    return response;
  }


}
